"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductSuggestions = void 0;
const ShopwareProductSearch_1 = __importDefault(require("../stores/ShopwareProductSearch"));
const getProductSuggestions = (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) {
        return Promise.resolve(undefined);
    }
    return ShopwareProductSearch_1.default.searchProducts({
        search: searchTerm,
    });
};
exports.getProductSuggestions = getProductSuggestions;
